import { IShift } from "./../../../helper/contracts";

export class Shift implements IShift {

    id: string;
    name: string;
    startTime: string;
    endTime: string;
    startDay: string;
    endDay: string;
    period: string;
    isActive: boolean;
    isSpecial: boolean;
    specialDay: any;
    operatorId: string;
    createdAt: Object;
    updatedAt: Object;

  constructor() {
    this.isActive = true;
    this.isSpecial = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/shift/shift.ts